<template>
  <div>
    <view-user
      :user-id="selectedUserId"
      v-model="isViewUserDialogVisible"
      @clearUserIdAndAuths="clearUserIdAndAuths()"
      @getUsers="getSequencePeople()"
    />
    <div class="d-flex flex-column"
         style="overflow-x: auto!important;">

      <slot name="steps-row" />

      <div class="d-flex">
        <v-col class="align-self-stretch"
               style="padding: 0 1px"
               cols="12"
               md="6"
               lg="4"
               xl="3"
               v-for="(people, id) in stepFilteredPeople"
               :key="id">
          <LeadCard v-for="person in people"
                    :key="person.id"
                    :card-color="getStepColor(getStepById(id).type)"
                    :person="person"
                    :step-type="getStepById(id).type"
                    style="margin: 2px 0"
                    @changeUserFromSequence="changeUserFromSequence"
                    @deleteUserFromSequence="deleteUserFromSequence"
                    @viewUser="viewUser(person.userId)"
                    @openEmailComposer="$emit('openEmailComposer', $event)">
          </LeadCard>
        </v-col>
      </div>
    </div>

    <v-col cols="12" class="align-center justify-end" :class="totalSequencePeople > 0 ? 'd-flex' : 'd-none'">
      <Pagination :pagination="pagination"
                  :total-items="totalSequencePeople"
                  @onPaginationChange="onPaginationChange($event)" />
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LeadCard from '@/pages/App/Sequences/Leads/LeadCard'
import Pagination from '@/components/widgets/Pagination'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'
export default {
  components: { LeadCard, Pagination, ViewUser },
  computed: {
    ...mapState({
      sequencePeople: state => state.sequences.sequencePeople,
      selectedSequence: state => state.sequences.selectedSequence,
      sequenceSteps: state => state.sequences.sequenceSteps,
      totalSequencePeople: state => state.sequences.totalSequencePeople
    }),
    stepFilteredPeople () {
      const filteredPeople = {}
      if (!(!this.sequenceSteps ||
          !Array.isArray(this.sequenceSteps) ||
          this.sequenceSteps.length === 0)) {
        const stepsIds = this.sequenceSteps.map(step => step.id)

        for (const id of stepsIds) {
          filteredPeople[id] = this.sequencePeople.filter(item => item.stepId === id)
        }
      }
      return filteredPeople
    }
  },
  data () {
    return {
      isViewUserDialogVisible: false,
      page: 1,
      selectedUserId: ''
    }
  },
  methods: {
    changeUserFromSequence (userId) {
      this.$emit('changeUserFromSequence', userId)
    },
    deleteUserFromSequence (userId) {
      this.$emit('deleteUserFromSequence', userId)
    },
    clearUserIdAndAuths () {
      this.selectedUserId = ''
    },
    getSequencePeople () {
      this.$emit('getSequencePeople')
    },
    getStepById (stepId) {
      if (!this.sequenceSteps ||
        !Array.isArray(this.sequenceSteps) ||
        this.sequenceSteps.length === 0) return { name: '', type: '' }
      const step = this.sequenceSteps.find(item => item.id === stepId)
      if (step) {
        const { name, type } = step
        return { name, type }
      }
      return { name: '', type: '' }
    },
    getStepColor (stepType) {
      switch (stepType) {
        case 'email':
          return 'rgb(245,98,120)'
        case 'mEmail':
          return 'rgb(245,98,120)'
        case 'task':
          return '#827de4'
        case 'sms':
          return '#fb8f6c'
        case 'social':
          return '#6796d6'
        case 'call':
          return '#5fcea1'
        default:
          return 'rgb(245,98,120)'
      }
    },
    onPaginationChange (pagination) {
      console.log(pagination, 'On pagination change from leads cards view')
      this.$emit('onPaginationChange', pagination)
    },
    viewUser (userId) {
      this.selectedUserId = userId
      this.isViewUserDialogVisible = true
    }
  },
  props: {
    pagination: {
      type: Object,
      required: true
    }
  }
}
</script>
